export const apiField = 'use_default_flat_slope_roof_snow_load';

const config: checkboxBlock = {
  type: 'Checkbox',
  label: 'useDefaultFlatSlopeRoofSnowLoad',
  apiField,
  id: 'useDefaultFlatSlopeRoofSnowLoad',
  aria_label: 'Use default flat/slope roof snow load',
};

export default config;
